export default __webpack_public_path__ + "static/omni-active-b33a44ab83c0fde2c5b67c5cb6183f0f.svg";